import React from "react";

import { Link } from "react-router-dom";
import { PageHeader, Table, Typography, Popconfirm, Space, Button, Divider, Row } from "antd";
import { displayDate } from "../../../../core/utils/date";
import OnlyAdmin from "../../../../core/components/auth/onlyAdmin";
import { LAYOUT_FINANCE_INVOICE_VENDOR_SHOW } from "../../navigation";

import { InvoiceStatusLabel } from "../../../../components/invoice/status";
import {
    INVOICE_STATUS_IN_REVIEW,
    INVOICE_STATUS_ACCEPTED,
    INVOICE_STATUS_PAID,
} from "../../../../components/invoice/status/const";

import { DeleteOutlined, CheckOutlined, DownloadOutlined, RollbackOutlined } from "@ant-design/icons";

import PropTypes from "prop-types";

const propTypes = {
    invoices: PropTypes.array,
    actionLoading: PropTypes.bool,

    onConfirmInvoice: PropTypes.func.isRequired,
    onRevertInvoice: PropTypes.func.isRequired,
    onDownloadInvoice: PropTypes.func.isRequired,
};

const defaultProps = {
    invoices: [],
    actionLading: false,
};

const { Text, Title } = Typography;

const ActionButtons = (props) => {
    const { record } = props;

    if (props.state === INVOICE_STATUS_IN_REVIEW) {
        return (
            <Space>
                {record.attachment && record.attachment.name && (
                    <Button
                        style={{ margin: 0 }}
                        icon={<DownloadOutlined />}
                        size="small"
                        onClick={() => props.onDownloadInvoice(record.id, record.attachment?.name)}
                        disabled={props.actionLoading}
                    />
                )}

                <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => props.onConfirmInvoice(record.id)}
                    okText="Yes"
                    cancelText="No"
                    disabled={props.actionLoading}
                >
                    <Button style={{ margin: 0 }} icon={<CheckOutlined />} size="small" disabled={props.actionLoading}>
                        Confirm
                    </Button>
                </Popconfirm>
                <OnlyAdmin>
                    <Popconfirm
                        title="Are you sure?"
                        onConfirm={() => props.onRemoveInvoice(record.id)}
                        okText="Yes"
                        cancelText="No"
                        disabled={props.actionLoading}
                    >
                        <Button
                            style={{ margin: 0 }}
                            icon={<DeleteOutlined />}
                            size="small"
                            danger
                            disabled={props.actionLoading}
                        />
                    </Popconfirm>
                </OnlyAdmin>
            </Space>
        );
    }

    if (props.state === INVOICE_STATUS_ACCEPTED) {
        return (
            <Space>
                {record.attachment && record.attachment.name && (
                    <Button
                        style={{ margin: 0 }}
                        icon={<DownloadOutlined />}
                        size="small"
                        onClick={() => props.onDownloadInvoice(record.id, record.attachment?.name)}
                        disabled={props.actionLoading}
                    />
                )}
                <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => props.onRevertInvoice(record.id)}
                    okText="Yes"
                    cancelText="No"
                    disabled={props.actionLoading}
                >
                    <Button
                        style={{ margin: 0 }}
                        icon={<RollbackOutlined />}
                        size="small"
                        disabled={props.actionLoading}
                        danger
                    />
                </Popconfirm>
            </Space>
        );
    }

    return (
        <Space>
            {record.attachment && record.attachment.name && (
                <Button
                    style={{ margin: 0 }}
                    icon={<DownloadOutlined />}
                    size="small"
                    onClick={() => props.onDownloadInvoice(record.id, record.attachment?.name)}
                    disabled={props.actionLoading}
                />
            )}
        </Space>
    );
};

const Invoices = (props) => {
    const columns = (props) => [
        {
            title: "ID",
            dataIndex: "display_id",
            key: "display_id",
            width: 100,
            render: (display_id, record) => (
                <Link to={LAYOUT_FINANCE_INVOICE_VENDOR_SHOW(record.id)}>{display_id}</Link>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 150,
            render: (st, record) => {
                return (
                    <Row justify="center">
                        <InvoiceStatusLabel status={st} />
                    </Row>
                );
            },
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => (date ? displayDate(date) : "-"),
            width: 100,
        },
        { title: "Number", dataIndex: "name", key: "name" },
        {
            title: "Amount",
            dataIndex: "amount_value",
            key: "amount_value",
            align: "right",
            width: 200,
            render: (price, record) => (
                <>
                    {price} {record.amount_type}
                </>
            ),
        },
        {
            title: "Action",
            key: "operation",
            align: "center",
            width: 310,
            render: (record) => {
                return <ActionButtons {...props} state={record.status} record={record} />;
            },
        },
    ];

    const invoices = props.invoices;

    if ((invoices || []).length == 0) {
        return null;
    }

    const displayNotes = (record) => {
        return <>{record.notes}</>;
    };
    const expandedRowClassName = (record, index, indent) => "able-finance-details";
    const rowExpandable = (record) => (record.notes ? true : false);
    const rowKey = (record) => record.id;

    return (
        <PageHeader ghost={false} title="Invoices">
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                expandable={{
                    expandedRowRender: displayNotes,
                    rowExpandable,
                    expandedRowClassName,
                }}
                rowKey={rowKey}
                dataSource={invoices}
                pagination={false}
                bordered={true}
            />
        </PageHeader>
    );
};

Invoices.propTypes = propTypes;
Invoices.defaultProps = defaultProps;

export default Invoices;
